module.exports = __webpack_public_path__ + "static/media/ic_submit_bills_grey.87a14e1d.svg";